import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'cp.components.imprint.pageTitle',
    defaultMessage: 'Imprint',
  },
})
